import { WORKFLOW_ACTIONS } from 'modules/workflows/constants';

export const propertyNames = {
  [WORKFLOW_ACTIONS.MODIFY_CHANNEL_SUBSCRIPTION]: {
    singular: 'channelId',
    plural: 'channelIds',
  },
  [WORKFLOW_ACTIONS.MODIFY_MESSAGE_TYPE]: {
    singular: 'messageTypeId',
    plural: 'messageTypeIds',
  },
};
